import styled from "styled-components";

export const Container = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding: 0;
  margin: 0;
`;

export const HeaderButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const ContainerForm = styled.div`
  margin-top: 24px;
  padding: 20px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
`;

export const ContainerInstrucoes = styled.div`
  margin: 24px 0;
  color: ${({ theme }) => theme.colors.neutral.neutral70};
`;
